import { create } from "zustand";

export enum Season {
  SPRING = "spring",
  SUMMER = "summer",
  AUTUMN = "autumn",
  WINTER = "winter",
}

export const SOLAR_SIMULATION_MIN_HOUR = 8;
export const SOLAR_SIMULATION_MAX_HOUR = 20;

const clampSolarHour = (hour: number) =>
  Math.max(SOLAR_SIMULATION_MIN_HOUR, Math.min(SOLAR_SIMULATION_MAX_HOUR, hour));

export interface SolarSimulationState {
  // État de la simulation
  isEnabled: boolean;
  season: Season;
  hour: number; // 8-20 (peut être décimal: 12.5 = 12h30)
  shadowsVisible: boolean;

  // Actions
  setEnabled: (enabled: boolean) => void;
  setSeason: (season: Season) => void;
  setHour: (hour: number) => void;
  setshadowsVisible: (visible: boolean) => void;
  reset: () => void;
}

const INITIAL_STATE = {
  isEnabled: true,
  season: Season.SUMMER,
  hour: 12, // midi par défaut
  shadowsVisible: true,
};

export const useSolarSimulationStore = create<SolarSimulationState>((set) => ({
  ...INITIAL_STATE,

  setEnabled: (enabled: boolean) => set({ isEnabled: enabled }),

  setSeason: (season: Season) => set({ season }),

  setHour: (hour: number) => {
    const normalizedHour = clampSolarHour(hour);
    set({ hour: normalizedHour });
  },

  setshadowsVisible: (visible: boolean) => set({ shadowsVisible: visible }),

  reset: () => set(INITIAL_STATE),
}));
